import React, { useEffect, useState } from "react";
import "./addTrainingCentreForm.scss";
import { styled } from "@mui/material/styles";
import Paper from "@mui/material/Paper";
import { Stack } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Grid from "@mui/material/Unstable_Grid2";
import { getTimezoneOption } from "../../globals/common_utilities/timezoneListing";
import InputTags from "../common/InputTags";
import Dropdown from "../../components/common/Dropdown";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { css } from "glamor";
import {
  isEmpty,
  validateEmail,
  validatePhone,
  validateName,
  validateScript,
  validateSkills,
} from "../../globals/common_utilities/utilities";
import {
  Redux_location,
  Redux_primary_aws,
  Redux_add_training_center,
} from "../../redux/forms";
import MultiLine_Spinner from "../multiline_spinner/Multiline_spinner";
import api_call from "../../globals/common_utilities/axios_old";
import download_icon from "../../Images/download_icon.svg";
import upload_icon from "../../Images/upload_icon.svg";
import { Box, Rating } from "@mui/material";
import * as XLSX from "xlsx";
import EDIT from "../../Images/formEdit.png";
import { Tooltip } from "@mui/material";
import {
  API,
  FOMRS,
  STATUS,
  ROLE,
  APP_ROUTES,
} from "../../globals/constants/index";
import green_icon from "../../globals/assets/green_computer.svg";
import CONSTANTURL from "../../globals/common_utilities/constanturls";
import CLOSE from "../../Images/close.svg";
import _ from "lodash";
import Cookies from "universal-cookie";
import Info from "../../Images/yellow_info_icon.svg";
import CsvDownloader from "react-csv-downloader";
const instructor_samples_files_JSON = [
  {
    name: "John Doe",
    email_id: "abc@gmaildummy.com",
    skills: "Films | Animations",
  },
];

const AddTrainingCenterForm = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { state } = useLocation();
  const [getTimeZoneList, setTimeZoneList] = useState();
  const [type, setType] = useState(state?.type || FOMRS.ADD);
  const [studioId, setSudioId] = useState(
    state?.id || "963d81bc-f265-4405-96bf-6743cd07cbb2"
  );
  const [instructorData, setInstructorData] = useState([]);
  const [uploadedFile, setUploadedFile] = useState([]);
  const [errorMessage, setErrorMessage] = useState();
  const [editCheckbox, setEditCheckbox] = useState(false);
  const [showLoader, setShowLoader] = useState(false);
  const [asInstructor, setAsInstructor] = useState([]);
  const api_res = useSelector((state) => {
    return state.add_training_center.Response;
  });
  const { loginResponse } = useSelector((state) => {
    return state.login;
  });

  const [aws_region, setAws_region] = useState();
  const [location, setLocation_list] = useState();
  const [uploadFilterData, setUploadFilterData] = useState([]);

  console.log("api_res--------->>", api_res);

  const cookies = new Cookies();
  const {
    id,
    name,
    device_id,
    studio_id,
    role_id,
    role_code,
    token,
    token_uniq_id,
    email_id,
    username,
    is_email_verify,
  } = cookies.get("loginData");

  const [formField, setFormField] = useState({
    contact_person_name: "",
    contact_no: "",
    email_id: "",
    username: "",
    about_training_center: "",
    time_zone: "",
    Training_center_name: "",
    skills: "",
    instructor_can_be_training_admin_checkbox: false,
    primary_aws_region: "",
    secondary_aws_region: "",
    location: "",
  });
  const [formField_error, setFormFild_error] = useState({
    contact_person_name_error: false,
    contact_no_error: false,
    email_id_error: false,
    username_error: false,
    about_training_center_error: false,
    time_zone_error: false,
    Training_center_name_error: false,
    skills_error: false,
    primary_aws_region_error: false,
    secondary_aws_region_error: false,
    location_error: false,
  });

  useEffect(() => {
    TimeZoneFun();
    getAWSLocationFun();
    getLocationFun();
    if (type === FOMRS.VIEW || type === FOMRS.EDIT) viewForm();
  }, []);
  const getToster = (res) => {
    console.log("ressss", res);
    if (res?.status === 200) {
      toast.success("Training center created successfully", {
        position: "bottom-right",
        autoClose: 3000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        style: { background: "#000", color: "#ffffff" },
      });
      gotolistingPage();
      // } else if (res?.status === 409) {
    } else if (res?.status === 409) {
      toast.error(res.err.data.msg || res.err.data.msg1, {
        position: "bottom-right",
        autoClose: 3000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        style: { background: "#000", color: "#ffffff" },
      });
    } else {
      // toast.success(`something gone Wrong !!`, {
      // 	position: 'bottom-right',
      // 	autoClose: 3000,
      // 	hideProgressBar: true,
      // 	closeOnClick: true,
      // 	pauseOnHover: true,
      // 	draggable: true,
      // 	progress: undefined,
      // });
    }
    // }
  };

  const TimeZoneFun = async () => {
    let timezone = await getTimezoneOption();
    setTimeZoneList(timezone);
  };

  const getLocationFun = async () => {
    const Response = await api_call(
      "GET",
      `${
        CONSTANTURL[process.env.REACT_APP_CUSTOM_ENV].STUDIO +
        API.END_POINTS.GET_LOCATION
      }`
      // API.BASE_URL.STUDIO + API.END_POINTS.GET_LOCATION
    );
    if (Response.status === 200) {
      setLocation_list(
        Response.data?.data?.rows.map((value) => ({
          id: value.id,
          value: value.id,
          label: value.code,
        }))
      );
    } else {
      setLocation_list([]);
    }
  };

  const getAWSLocationFun = async () => {
    let params = {
      cloud_type: "AWS",
    };
    const Response = await api_call(
      "GET",
      `${
        CONSTANTURL[process.env.REACT_APP_CUSTOM_ENV].STUDIO +
        API.END_POINTS.GET_AWS_REGION
      }`,
      params
      // API.BASE_URL.STUDIO + API.END_POINTS.GET_AWS_REGION
    );
    if (Response.status === 200) {
      setAws_region(
        Response.data?.data?.rows.map((value) => ({
          id: value.id,
          value: value.id,
          label: value.region_name,
        }))
      );
    } else {
      setAws_region([]);
    }
  };
  const isValid = () => {
    if (formField.instructor_can_be_training_admin_checkbox === true) {
      if (
        !isEmpty(formField.contact_person_name) &&
        formField.contact_person_name.trim().length !== 0 &&
        !isEmpty(formField.username) &&
        formField.username.trim().length !== 0 &&
        !isEmpty(formField.Training_center_name) &&
        formField.Training_center_name.trim().length !== 0 &&
        !isEmpty(formField.email_id) &&
        formField.email_id.trim().length !== 0 &&
        !isEmpty(formField.location) &&
        formField.skills?.length !== 0 &&
        !isEmpty(formField.time_zone) &&
        validateEmail(formField.email_id) &&
        validateSkills(formField.skills) &&
        validateScript(formField.username) &&
        validateScript(formField.Training_center_name) &&
        validateScript(formField.time_zone) &&
        validateScript(formField.location) &&
        validateScript(formField.email_id) &&
        validateScript(formField.contact_person_name)
      ) {
        return true;
      } else {
        return false;
      }
    } else {
      if (
        !isEmpty(formField.contact_person_name) &&
        formField.contact_person_name.trim().length !== 0 &&
        !isEmpty(formField.username) &&
        formField.username.trim().length !== 0 &&
        formField.Training_center_name.trim().length !== 0 &&
        !isEmpty(formField.email_id) &&
        formField.email_id.trim().length !== 0 &&
        !isEmpty(formField.location) &&
        validateEmail(formField.email_id) &&
        validateScript(formField.username) &&
        validateScript(formField.email_id) &&
        validateScript(formField.contact_person_name) &&
        validateScript(formField.Training_center_name) &&
        validateScript(formField.location)
      ) {
        return true;
      } else {
        return false;
      }
    }
  };
  const handleButtonClick = () => {
    document.getElementById("file-upload").click();
  };
  const uploadValid = () => {
    let temp = [...uploadedFile];
    let valid = true;
    temp = temp.map((item) => {
      if (item.zone === "" || item.zone === null || item.zone === undefined) {
        valid = false;
        toast.error("Please select timezones in bulk upload", {
          position: "bottom-right",
          autoClose: 3000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          style: { background: "#000", color: "#ffffff" },
        });
      }
    });
    return valid;
  };

  const onSubmit = async () => {
    console.log("item.zone---------->>", isValid());
    let temp = [
      ...uploadedFile,
      {
        email_id: formField.email_id,
        name: formField.contact_person_name,
        username: formField.username,
        skills: JSON.stringify(formField.skills),
        zone: formField.time_zone,
      },
    ];
    console.log("temp----------->.", temp);
    if ((await isValid()) && (await uploadValid())) {
      let bodyParam = {
        admin_name: formField.contact_person_name,
        username: formField.username,
        email: formField.email_id,
        studio_name: formField.Training_center_name,
        contact_no: formField.contact_no,
        skills:
          formField.instructor_can_be_training_admin_checkbox === true
            ? JSON.stringify([...formField.skills])
            : "",
        about: formField.about_training_center,
        instructor:
          formField.instructor_can_be_training_admin_checkbox === true
            ? temp
            : uploadedFile,
        primary_region_id: "",
        secondary_region_id: "",
        location_id: formField.location,
      };
      let response = "";
      if (type === FOMRS.ADD) {
        let createdBy = {
          id: id,
          name: name,
        };
        bodyParam.createdBy = createdBy;
      } else {
        let createdBy = {
          id: id,
          name: name,
        };
        bodyParam.createdBy = createdBy;
      }
      console.log("reuqrest -------->>", bodyParam);
      // return
      if (type === FOMRS.ADD) {
        setShowLoader(true);
        response = await api_call(
          "POST",
          `${
            CONSTANTURL[process.env.REACT_APP_CUSTOM_ENV].STUDIO +
            API.END_POINTS.TRAININGCENTER_ENDPOINT
          }`,
          // API.BASE_URL.STUDIO + API.END_POINTS.TRAININGCENTER_ENDPOINT,
          {},
          {},
          bodyParam
        );
        getToster(response);
      } else if (type === FOMRS.EDIT) {
        setShowLoader(true);
        response = await api_call(
          "POST",
          `${
            CONSTANTURL[process.env.REACT_APP_CUSTOM_ENV].STUDIO +
            API.END_POINTS.TRAININGCENTER_UPDATE
          }?studio_id=${studioId}`,
          {},
          {},
          bodyParam
        );
        if (response?.status === 200) {
          toast.success("Training center updated successfully", {
            position: "bottom-right",
            autoClose: 3000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            style: { background: "#000", color: "#ffffff" },
          });
          gotolistingPage();
          // } else if (response?.status === 409) {
        } else if (response?.status === 409) {
          toast.error(response.err.data.msg || response.err.data.msg1, {
            position: "bottom-right",
            autoClose: 3000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            style: { background: "#000", color: "#ffffff" },
          });
        } else {
          // toast.success(`something gone Wrong !!`, {
          // 	position: 'bottom-right',
          // 	autoClose: 3000,
          // 	hideProgressBar: true,
          // 	closeOnClick: true,
          // 	pauseOnHover: true,
          // 	draggable: true,
          // 	progress: undefined,
          // });
        }
      }
      setShowLoader(false);
    } else {
      setFormFild_error(() => {
        return {
          ...formField_error,
          contact_person_name_error:
            isEmpty(formField.contact_person_name) ||
            formField.contact_person_name.trim().length === 0 ||
            !validateScript(formField.contact_person_name),
          Training_center_name_error:
            isEmpty(formField.Training_center_name) ||
            formField.Training_center_name.trim().length === 0 ||
            !validateScript(formField.Training_center_name),
          contact_no_error:
            isEmpty(formField.contact_no) ||
            formField.contact_no.trim().length === 0 ||
            !validatePhone(formField.contact_no) ||
            !validateScript(formField.contact_no),
          email_id_error:
            isEmpty(formField.email_id) ||
            formField.email_id.trim().length === 0 ||
            !validateEmail(formField.email_id) ||
            !validateScript(formField.email_id),
          about_training_center_error:
            isEmpty(formField.about_training_center) ||
            formField.about_training_center.trim().length === 0 ||
            !validateScript(formField.about_training_center),
          username_error:
            isEmpty(formField.username) ||
            formField.username.trim().length === 0 ||
            !validateScript(formField.username),
          time_zone_error: formField.instructor_can_be_training_admin_checkbox
            ? isEmpty(formField.time_zone) ||
              !validateScript(formField.time_zone)
            : null,
          skills_error: formField.instructor_can_be_training_admin_checkbox
            ? formField.skills.length === 0 ||
              !validateSkills(formField.skills) ||
              !validateScript(formField.skills)
            : null,
          primary_aws_region_error:
            isEmpty(formField.primary_aws_region) ||
            !validateScript(formField.primary_aws_region),
          secondary_aws_region_error:
            isEmpty(formField.secondary_aws_region) ||
            !validateScript(formField.secondary_aws_region),
          location_error:
            isEmpty(formField.location) || !validateScript(formField.location),
        };
      });
    }
  };

  const timezone_fun = (e) => {
    let data1 = e.value.split("$");
    setFormField({ ...formField, time_zone: data1[0] });
    setFormFild_error({
      ...formField_error,
      time_zone_error: false,
    });
  };
  const primary_aws_fun = (e) => {
    setFormField({ ...formField, primary_aws_region: e.value });
    setFormFild_error({
      ...formField_error,
      primary_aws_region_error: false,
    });
  };
  const secondary_aws_fun = (e) => {
    setFormField({ ...formField, secondary_aws_region: e.value });
    setFormFild_error({
      ...formField_error,
      secondary_aws_region_error: false,
    });
  };
  const location_fun = (e) => {
    setFormField({ ...formField, location: e.value });
    setFormFild_error({
      ...formField_error,
      location_error: false,
    });
  };

  const onTimeZoneChange = async (e, i, data) => {
    let tempData = [...uploadedFile];
    let data1 = e.value.split("$");
    console.log("hhgsffdsgfdgsd---", data1);
    tempData[i].zone = data1[0];
    setUploadedFile(tempData);
  };

  const viewForm = async () => {
    let params = { studio_id: studioId };

    setShowLoader(true);
    const { status, data } = await api_call(
      "GET",
      `${
        CONSTANTURL[process.env.REACT_APP_CUSTOM_ENV].STUDIO +
        API.END_POINTS.TRAININGCENTER_ENDPOINT
      }`,
      params
    );
    if (status === 200) {
      setShowLoader(false);
      let instructorData = data?.data?.result?.users?.filter(
        (value) => value.email_id === data?.data?.result?.email
      );
      setUploadedFile(
        data?.data?.result?.users.filter(
          (value) => value.email_id !== data?.data?.result?.email
        )
      );
      let data_check = data?.data?.result.users.filter(
        (item) => item.email_id === data?.data?.result?.email
      );
      setAsInstructor([...data_check]);
      setFormField({
        ...formField,
        contact_person_name: data?.data?.result?.admin_name,
        contact_no: data?.data?.result?.contact_no,
        email_id: data?.data?.result?.email,
        username: data?.data?.result?.username,
        about_training_center: data?.data?.result?.about,
        time_zone: instructorData[0]?.zone,
        instructor_can_be_training_admin_checkbox: instructorData[0]?.skills
          ? true
          : false,
        skills: instructorData[0]?.skills
          ? JSON.parse(instructorData[0]?.skills)
          : [],
        Training_center_name: data?.data?.result?.studio_name,
        primary_aws_region: data?.data?.result?.primary_region_id,
        secondary_aws_region: data?.data?.result?.secondary_region_id,
        location: data?.data?.result?.location?.id,
      });
    } else {
      setUploadedFile([]);
    }
  };

  const view_secondary = async (value) => {
    return aws_region.map((data) => {
      if (data.value == value) {
        console.log("data === value-------->>", data.label);

        return data;
      }
    });
  };

  const validateColumFile = (csv) => {
    var lines = csv.split("\n");
    let validation = true;
    const contact_regex = /^[0-9]*(?:\.\d{1,2})?$/;
    var headers = lines[0].split(",");
    if (lines.length > 1) {
      for (var i = 1; i < lines.length - 1; i++) {
        var obj = {};
        var currentline = lines[i].split(",");

        for (var k = 0; k < headers.length; k++) {
          obj[headers[k]] = currentline[k]?.trim();
        }
        if (obj.name === "") {
          validation = false;
          setErrorMessage(`Name field data incorrect or empty`);
          toast.error(`Name field data incorrect or empty`, {
            position: "bottom-right",
            autoClose: 3000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            style: { background: "#000", color: "#ffffff" },
          });

          break;
        } else if (obj.email_id === "") {
          validation = false;
          setErrorMessage(`email field data incorrect or empty`);
          toast.error(`email field data incorrect or empty`, {
            position: "bottom-right",
            autoClose: 3000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            style: { background: "#000", color: "#ffffff" },
          });
          break;
        } else if (obj.skills === "") {
          validation = false;
          setErrorMessage(`skills field data incorrect or empty`);
          toast.error(`skills field data incorrect or empty`, {
            position: "bottom-right",
            autoClose: 3000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            style: { background: "#000", color: "#ffffff" },
          });
          break;
        } else if (!validateScript(obj.name?.trim())) {
          validation = false;
          setErrorMessage(`name field data incorrect`);
          toast.error(`name field data incorrect`, {
            position: "bottom-right",
            autoClose: 3000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            style: { background: "#000", color: "#ffffff" },
          });
          break;
        } else if (!validateEmail(obj.email_id?.trim())) {
          validation = false;
          setErrorMessage(`email field data incorrect `);
          toast.error(`email field data incorrect `, {
            position: "bottom-right",
            autoClose: 3000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            style: { background: "#000", color: "#ffffff" },
          });
          break;
        } else if (!validateSkills(obj.skills?.trim())) {
          validation = false;
          setErrorMessage(`skills field data incorrect `);
          toast.error(`skills field data incorrect `, {
            position: "bottom-right",
            autoClose: 3000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            style: { background: "#000", color: "#ffffff" },
          });
          break;
        } else {
          validation = true;
        }
      }
      return validation;

      //return result; //JavaScript object
    } else {
      validation = false;
      setErrorMessage(`Blank File with No Records`);
      toast.error(`Blank File with No Record`, {
        position: "bottom-right",
        autoClose: 3000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        style: { background: "#000", color: "#ffffff" },
      });
      return validation;
    }
    //JSON
  };

  const validateFile = (csv) => {
    var lines = csv.split("\n");
    let validation = true;

    var result = ["name", "email_id", "skills"];

    var headers = lines[0].split(",");
    if (headers.length === result.length) {
      for (var j = 0; j < result.length; j++) {
        if (headers.includes(result[j])) {
          validation = true;
        } else {
          setErrorMessage(`${result[j]} field is missing`);
          validation = false;
          break;
        }
      }
    } else {
      toast.error(
        `Invalid file format, Please download sample file and upload instructor's data`,
        {
          position: "bottom-right",
          autoClose: 3000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          toastId: "invalidfields",
          style: { background: "#000", color: "#ffffff" },
        }
      );
      validation = false;
    }
    return validation; //JSON
  };

  const onFileChange = (e) => {
    // setState({ selectedFile: e.target.files[0] });
    var f = e.target.files[0];
    var file = e.target.files[0];
    var filename = file.name ? file.name : "";
    var regex = new RegExp("(.*?).(csv)$");
    if (regex.test(filename)) {
      const reader = new FileReader();
      reader.onload = (evt) => {
        // evt = on_file_select event
        /* Parse data */
        const bstr = evt.target.result;
        const wb = XLSX.read(bstr, { type: "binary" });
        /* Get first worksheet */
        const wsname = wb.SheetNames[0];
        const ws = wb.Sheets[wsname];
        /* Convert array of arrays */
        const data = XLSX.utils.sheet_to_csv(ws, { header: 1 });
        // convertToJson(data)
        if (validateFile(data) && validateColumFile(data)) {
          // toast.success("File Uploaded Successfully ", {
          //   position: "bottom-right",
          //   autoClose: 3000,
          //   hideProgressBar: true,
          //   closeOnClick: true,
          //   pauseOnHover: true,
          //   draggable: true,
          //   progress: undefined,
          //   className: "green-background",
          // });
          let convertedData = [...JSON.parse(convertToJson(data))];
          convertedData = convertedData.map((item) => {
            let temp = JSON.stringify(
              item.skills.replaceAll("|", ",").trim().split(",")
            );
            item = {
              ...item,
              skills: temp,
              zone: "",
            };
            return item;
          });
          const instructor = [
            ...instructorData,
            ...uploadedFile,
            ...convertedData,
          ];
          // setInstructorData(instructor);
          // setUploadFilterData(instructor);
          setUploadedFile(_.unionBy(instructor, "email_id"));
        } else {
        }
      };

      reader.readAsBinaryString(f);
    } else {
      toast.success(`Please select csv file`, {
        position: "bottom-right",
        autoClose: 3000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        style: { background: "#000", color: "#ffffff" },
      });
    }
    e.target.value = null;
    // ReactGA.event(GA_TAG_LIST.ADMINADDSTUDIO.BROWSE);
  };
  const convertToJson = (csv) => {
    var lines = csv.split("\n");

    var result = [];

    var headers = lines[0].split(",");

    for (var i = 1; i < lines.length; i++) {
      var obj = {};
      var currentline = lines[i].split(",");

      for (var j = 0; j < headers.length; j++) {
        obj[headers[j]] = currentline[j]?.trim();
      }
      const arr1 = instructorData.filter((d) => d.email_id === obj.email_id);
      if (obj.name === "" || arr1.length > 0) {
      } else {
        result.push(obj);
      }
    }

    const key = "email_id";
    const arrayUniqueByKey = [
      ...new Map(result.map((item) => [item[key], item])).values(),
    ];
    return JSON.stringify(arrayUniqueByKey);
  };

  const setMulticheckbox = (data) => {
    let value = data;
    setUploadedFile((prev) =>
      uploadedFile.includes(value)
        ? prev.filter((cur) => cur?.email_id !== value?.email_id)
        : [...prev, value]
    );
  };

  const gotolistingPage = (training) => {
    navigate(APP_ROUTES.ROUTE_TRAININGCENTER, {
      state: {},
    });
  };

  return (
    <>
      {console.log("formField----------->>", formField)}
      <div className="mainContainer">
        {showLoader ? (
          <MultiLine_Spinner />
        ) : (
          <>
            <Grid
              xs={12}
              sm={12}
              md={12}
              lg={12}
              className="TitleContainer"
              container
              justifyContent={"space-between"}
            >
              <div>
                <span className="TitleName" onClick={gotolistingPage}>
                  {" "}
                  {`Training Center >>`}{" "}
                </span>
                <span className="TrainingName">
                  {type === FOMRS.ADD
                    ? "Add "
                    : type === FOMRS.EDIT
                    ? "Edit "
                    : "View "}
                  Training Center
                </span>
              </div>
            </Grid>
            <Grid
              container
              columnSpacing={2}
              rowSpacing={1.5}
              className="parentContainer"
            >
              <Stack
                width="100%"
                justifyContent={"flex-end"}
                alignItems="flex-end"
              >
                {type !== FOMRS.ADD && (
                  <div
                    className={
                      editCheckbox
                        ? "edit-add-center-form active_c"
                        : "edit-add-center-form"
                    }
                  >
                    <img
                      src={EDIT}
                      width="55px"
                      height="55px"
                      onClick={(e) => {
                        setEditCheckbox(!editCheckbox);
                        setType(editCheckbox ? "VIEW" : "EDIT");
                      }}
                    />
                  </div>
                )}
              </Stack>
              <Grid Item xs={12} sm={12} md={6} lg={6} className="fieldDiv">
                <Grid container>
                  <Grid xs={12} sm={12} md={12} lg={12} className="formLabel">
                    UATC
                  </Grid>
                  <Grid xs={11} sm={11} md={11} lg={11}>
                    <input
                      placeholder=" Please enter UATC *"
                      className="addTrainingInput"
                      value={formField?.Training_center_name}
                      disabled={type === FOMRS.VIEW}
                      onChange={(e) => {
                        setFormField({
                          ...formField,
                          Training_center_name: e.target.value,
                        });
                        setFormFild_error({
                          ...formField_error,
                          Training_center_name_error: false,
                        });
                      }}
                    />
                    {formField_error.Training_center_name_error && (
                      <small className="error small_f">
                        Enter Valid UATC *
                      </small>
                    )}
                  </Grid>
                  <Grid item xs={1} sm={1} md={1} lg={1} xl={1}>
                    <div className="info_image">
                      <Tooltip
                        title="
                        This is the name of the Unreal Authorized Training Center (UATC). Example 'John Smith'"
                        placement="top-start"
                        arrow
                      >
                        <img src={Info} className="tooltip-align" />
                      </Tooltip>
                    </div>
                  </Grid>
                </Grid>
              </Grid>
              <Grid Item xs={12} sm={12} md={6} lg={6} className="fieldDiv">
                <Grid container>
                  <Grid xs={12} sm={12} md={12} lg={12} className="formLabel">
                    UATC Contact Person
                  </Grid>
                  <Grid xs={11} sm={11} md={11} lg={11}>
                    <input
                      placeholder="Admin Staff name (who can schedule UE classes)"
                      className="addTrainingInput"
                      value={formField?.contact_person_name}
                      disabled={type === FOMRS.VIEW}
                      onChange={(e) => {
                        setFormField({
                          ...formField,
                          contact_person_name: e.target.value,
                        });
                        setFormFild_error({
                          ...formField_error,
                          contact_person_name_error: false,
                        });
                      }}
                    />
                    {formField_error.contact_person_name_error && (
                      <small className="error small_f">
                        Enter Valid UATC Contact Person name*
                      </small>
                    )}
                  </Grid>
                  <Grid item xs={1} sm={1} md={1} lg={1} xl={1}>
                    <div className="info_image">
                      <Tooltip
                        title="
                        This is the name of the admin of this training center. Example 'John Smith'"
                        placement="top-start"
                        arrow
                      >
                        <img src={Info} className="tooltip-align" />
                      </Tooltip>
                    </div>
                  </Grid>
                </Grid>
              </Grid>
              {/* <Grid Item xs={12} sm={12} md={6} lg={6} className="fieldDiv">
                <Grid container>
                  <Grid xs={12} sm={12} md={12} lg={12} className="formLabel">
                    Contact no
                  </Grid>
                  <Grid xs={11} sm={11} md={11} lg={11}>
                    <input
                      placeholder="Admin staff of the UATC (Phone number)"
                      className="addTrainingInput"
                      value={formField?.contact_no}
                      disabled={type === FOMRS.VIEW}
                      onChange={(e) => {
                        setFormField({
                          ...formField,
                          contact_no: e.target.value,
                        });
                        setFormFild_error({
                          ...formField_error,
                          contact_no_error: false,
                        });
                      }}
                    />
                    {formField_error.contact_no_error && (
                      <small className="error small_f">
                        Enter Valid contact no *
                      </small>
                    )}
                  </Grid>
                  <Grid item xs={1} sm={1} md={1} lg={1} xl={1}>
                    <div className="info_image">
                      <Tooltip
                        title="
                        Please provide the contact number of the Unreal Authorized Training Center"
                        placement="top-start"
                        arrow
                      >
                        <img src={Info} className="tooltip-align" />
                      </Tooltip>
                    </div>
                  </Grid>
                </Grid>
              </Grid> */}
              <Grid Item xs={12} sm={12} md={6} lg={6} className="fieldDiv">
                <Grid container>
                  <Grid xs={12} sm={12} md={12} lg={12} className="formLabel">
                    Email ID
                  </Grid>
                  <Grid xs={11} sm={11} md={11} lg={11}>
                    <input
                      className="addTrainingInput"
                      value={formField?.email_id}
                      disabled={type === FOMRS.VIEW}
                      placeholder="Email Address"
                      onChange={(e) => {
                        setFormField({
                          ...formField,
                          email_id: e.target.value,
                        });
                        setFormFild_error({
                          ...formField_error,
                          email_id_error: false,
                        });
                      }}
                    />
                    {formField_error.email_id_error && (
                      <small className="error small_f">
                        Enter Valid Email id *
                      </small>
                    )}
                  </Grid>
                  <Grid item xs={1} sm={1} md={1} lg={1} xl={1}>
                    <div className="info_image">
                      <Tooltip
                        title="
                        Please provide the contact number of the Unreal Authorized Training CenterAll communication regarding training activities concerning this training center will be sent to this email ID. Please ensure this is a valid email ID."
                        placement="top-start"
                        arrow
                      >
                        <img src={Info} className="tooltip-align" />
                      </Tooltip>
                    </div>
                  </Grid>
                </Grid>
              </Grid>
              <Grid Item xs={12} sm={12} md={6} lg={6} className="fieldDiv">
                <Grid container>
                  <Grid xs={12} sm={12} md={12} lg={12} className="formLabel">
                    Location
                  </Grid>
                  <Grid xs={11} sm={11} md={11} lg={11}>
                    <Dropdown
                      value={location?.filter(
                        (loca) => formField?.location === loca?.value
                      )}
                      isDisabled={type === FOMRS.VIEW}
                      clearable
                      options={location}
                      onChange={(e) => location_fun(e)}
                      selection
                      placeholder="Select location"
                    />
                    {formField_error.location_error && (
                      <small className="error small_f">
                        Select Valid location *
                      </small>
                    )}
                  </Grid>
                  <Grid item xs={1} sm={1} md={1} lg={1} xl={1}>
                    <div className="info_image">
                      <Tooltip
                        title="
                        Select the nearest region to Unreal Authorized Training Center's location. This is only for self-reference and tagging purposes."
                        placement="top-start"
                        arrow
                      >
                        <img src={Info} className="tooltip-align" />
                      </Tooltip>
                    </div>
                  </Grid>
                </Grid>
              </Grid>
              {/* <Grid Item xs={12} sm={12} md={6} lg={6} className="fieldDiv">
								<Grid container>
									<Grid xs={12} sm={12} md={12} lg={12} className="formLabel">
										Primary AWS Region
									</Grid>
									<Grid xs={12} sm={12} md={12} lg={12}>
										<Dropdown
											value={aws_region?.filter(
												(aws) => formField?.primary_aws_region === aws?.value
											)}
											isDisabled={type === FOMRS.VIEW}
											clearable
											options={aws_region}
											onChange={(e) => primary_aws_fun(e)}
											selection
											placeholder="Select primary AWS Region"
										/>
										{formField_error.primary_aws_region_error && (
											<small className="error small_f">
												Enter Valid Primary aws Region *
											</small>
										)}
									</Grid>
								</Grid>
							</Grid>
							<Grid Item xs={12} sm={12} md={6} lg={6} className="fieldDiv">
								<Grid container>
									<Grid xs={12} sm={12} md={12} lg={12} className="formLabel">
										Secondary AWS Region
									</Grid>
									<Grid xs={12} sm={12} md={12} lg={12}>
										<Dropdown
											value={aws_region?.filter(
												(aws) => formField?.secondary_aws_region === aws?.value
											)}
											isDisabled={type === FOMRS.VIEW}
											clearable
											options={aws_region}
											onChange={(e) => secondary_aws_fun(e)}
											selection
											placeholder="Select secondary AWS Region"
										/>
										{formField_error.secondary_aws_region_error && (
											<small className="error small_f">
												Enter Valid secondary aws Region *
											</small>
										)}
									</Grid>
								</Grid>
							</Grid> */}
              <Grid Item xs={12} sm={12} md={6} lg={6} className="fieldDiv">
                <Grid container>
                  <Grid xs={12} sm={12} md={12} lg={12} className="formLabel">
                    Epic User Name
                  </Grid>
                  <Grid xs={11} sm={11} md={11} lg={11}>
                    <input
                      placeholder="Epic ID of Admin staff of the UATC"
                      className="addTrainingInput"
                      value={formField?.username}
                      disabled={type === FOMRS.VIEW}
                      onChange={(e) => {
                        setFormField({
                          ...formField,
                          username: e.target.value,
                        });
                        setFormFild_error({
                          ...formField_error,
                          username_error: false,
                        });
                      }}
                    />
                    {formField_error.username_error && (
                      <small className="error small_f">
                        Enter Valid username *
                      </small>
                    )}
                  </Grid>
                  <Grid item xs={1} sm={1} md={1} lg={1} xl={1}>
                    <div className="info_image">
                      <Tooltip
                        title="
                        This connects Cumulo to the Unreal Authorized Training Center's Epic Games login. It's important to get this right. The instructor can get their 'Display Name' from their Epic Games account. Please ask them to go to https://www.epicgames.com/account/personal to see their Display Name. Display Name is case sensitive"
                        placement="top-start"
                        arrow
                      >
                        <img src={Info} className="tooltip-align" />
                      </Tooltip>
                    </div>
                  </Grid>
                </Grid>
              </Grid>
              <Grid Item xs={12} sm={12} md={12} lg={12} className="fieldDiv">
                <Grid
                  Item
                  xs={12}
                  sm={12}
                  md={12}
                  lg={12}
                  container
                  direction={"row"}
                  alignItems="center"
                >
                  <input
                    disabled={type === FOMRS.VIEW || asInstructor.length > 0}
                    type="checkbox"
                    onClick={() =>
                      setFormField({
                        ...formField,
                        instructor_can_be_training_admin_checkbox:
                          !formField?.instructor_can_be_training_admin_checkbox,
                      })
                    }
                    style={{ width: "18px", height: "18px" }}
                    checked={
                      formField?.instructor_can_be_training_admin_checkbox
                    }
                  />
                  <span className="addTrainingCheckbox">
                    Assign Training Center admin also as an instructor?
                  </span>
                </Grid>
              </Grid>
              {formField?.instructor_can_be_training_admin_checkbox && (
                <>
                  <Grid Item xs={12} sm={12} md={6} lg={6} className="fieldDiv">
                    <Grid container>
                      <Grid
                        xs={12}
                        sm={12}
                        md={12}
                        lg={12}
                        className="formLabel"
                      >
                        Instructor Skills
                      </Grid>
                      <Grid xs={12} sm={12} md={12} lg={12}>
                        <InputTags
                          placeholder="Add instructor skills (eg: Gaming) &amp; hit enter"
                          readOnly={type === FOMRS.VIEW}
                          tags={
                            formField?.skills.length > 0 &&
                            formField?.skills.map((data) => data)
                          }
                          onChange={(e) => {
                            setFormField({ ...formField, skills: e });
                            setFormFild_error({
                              ...formField_error,
                              skills_error: false,
                            });
                          }}
                        />
                        {formField_error.skills_error && (
                          <small className="error small_f">
                            Enter Valid skills *
                          </small>
                        )}
                      </Grid>
                    </Grid>
                  </Grid>
                  <Grid Item xs={12} sm={12} md={6} lg={6} className="fieldDiv">
                    <Grid container>
                      <Grid
                        xs={12}
                        sm={12}
                        md={12}
                        lg={12}
                        className="formLabel"
                      >
                        Instructor Timezone
                      </Grid>
                      <Grid xs={12} sm={12} md={12} lg={12}>
                        <Dropdown
                          clearable
                          value={getTimeZoneList?.filter(
                            (zone) => formField?.time_zone === zone?.value
                          )}
                          isDisabled={type === FOMRS.VIEW}
                          options={getTimeZoneList}
                          onChange={(e) => timezone_fun(e)}
                          selection
                          placeholder="Select Instructor Timezone"
                        />
                        {formField_error.time_zone_error && (
                          <small className="error small_f">
                            Select Valid time_zone *
                          </small>
                        )}
                      </Grid>
                    </Grid>
                  </Grid>
                </>
              )}

              {/* <Grid Item xs={12} sm={12} md={12} lg={12} className="fieldDiv">
                <Grid container>
                  <Grid xs={12} sm={12} md={12} lg={12} className="formLabel">
                    About UATC
                  </Grid>
                  <Grid xs={11.5} sm={11.5} md={11.5} lg={11.5}>
                    <textarea
                      rows={3}
                      placeholder="Share a short paragraph about your UATC and the courses offered (for example, specialized in AEC and /or Virtual Production, Animation, Game development, etc)"
                      className="addTrainingTextarea"
                      value={formField?.about_training_center}
                      disabled={type === FOMRS.VIEW}
                      onChange={(e) => {
                        setFormField({
                          ...formField,
                          about_training_center: e.target.value,
                        });
                        setFormFild_error({
                          ...formField_error,
                          about_training_center_error: false,
                        });
                      }}
                    />
                    {formField_error.about_training_center_error && (
                      <small className="error small_f">
                        Please enter detail about Training Center*
                      </small>
                    )}
                  </Grid>
                  <Grid item xs={0.5} sm={0.5} md={0.5} lg={0.5} xl={0.5}>
                    <div className="info_image">
                      <Tooltip
                        title="
                        Please provide a brief info about the Unreal Authorized Training Center. Eg: 'John Smith UATC primarily teaches game development and has over 8 years of teaching experience'"
                        placement="top-start"
                        arrow
                      >
                        <img src={Info} className="tooltip-align" />
                      </Tooltip>
                    </div>
                  </Grid>
                </Grid>
              </Grid> */}

              {type === FOMRS.VIEW ? (
                ""
              ) : (
                <Grid Item xs={12} sm={12} md={12} lg={12} className="fieldDiv">
                  <Grid container>
                    <Grid xs={12} sm={12} md={12} lg={12} className="formLabel">
                      {/* First download the sample file and then upload file to
											continue */}
                      Please upload the list of instructors to your training
                      center
                    </Grid>
                    <Grid
                      container
                      direction="row"
                      justifyContent="center"
                      alignItems="center"
                      xs={12}
                      sm={12}
                      md={12}
                      lg={12}
                    >
                      <Grid item xs={12} sm={12} md={8} lg={8}>
                        <Box
                          className="add_training_center_uploade_file"
                          direction={"row"}
                          justifyContent={"center"}
                          alignItems={"center"}
                          onClick={() => handleButtonClick()}
                        >
                          <img src={upload_icon} />
                          <Box>
                            <label>
                              Browse
                              <input
                                id="file-upload"
                                type="file"
                                disabled={type === FOMRS.VIEW}
                                onChange={onFileChange}
                              />
                            </label>
                          </Box>
                        </Box>
                      </Grid>
                      <Grid
                        item
                        xs={12}
                        sm={12}
                        md={4}
                        lg={4}
                        className="add_training_center_downlod_file"
                      >
                        <CsvDownloader
                          //   // id="link"
                          //   // href="https://unreal-engine-ui.s3.ap-south-1.amazonaws.com/students_samples_files.csv"
                          //   // download
                          // >

                          id="export_csv"
                          filename="Instructor_samples_files.csv"
                          separator=","
                          columns={[
                            { displayName: "name", id: "name" },
                            {
                              displayName: "email_id",
                              id: "email_id",
                            },

                            { displayName: "skills", id: "skills" },
                          ]}
                          wrapColumnChar=""
                          datas={instructor_samples_files_JSON}
                        >
                          Download sample file <img src={download_icon} />
                        </CsvDownloader>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              )}
              <Grid
                Item
                xs={12}
                sm={12}
                md={12}
                lg={12}
                className="fieldDiv add_training_center_machien_required"
                minHeight={"180px"}
              >
                {uploadedFile &&
                  uploadedFile.map((data, i) => {
                    {
                      console.log("data--------@@@@@@@@@----------->>>", data);
                    }
                    return (
                      <Grid
                        className="machine"
                        container
                        justifyContent={"left"}
                        alignItems={"center"}
                        direction="row"
                        key={i}
                      >
                        <Grid Item xs={12} sm={1} md={1} lg={1}>
                          {type === FOMRS.VIEW ? (
                            ""
                          ) : (
                            <img
                              src={CLOSE}
                              style={{ width: "20px" }}
                              onClick={() => {
                                if (type !== FOMRS.VIEW) {
                                  setMulticheckbox(data);
                                }
                              }}
                            />
                          )}
                        </Grid>
                        <Grid
                          Item
                          xs={12}
                          sm={11}
                          md={3}
                          lg={3}
                          className="small_f"
                        >
                          <Grid
                            container
                            justifyContent={"left"}
                            alignItems={"center"}
                            direction="row"
                          >
                            <img src={green_icon} />
                            <span>{data?.name}</span>
                          </Grid>
                        </Grid>
                        <Grid
                          Item
                          xs={12}
                          sm={6}
                          md={4}
                          lg={4}
                          className="small_f"
                        >
                          <Box> {data?.email_id}</Box>
                        </Grid>
                        <Grid
                          Item
                          xs={12}
                          sm={6}
                          md={4}
                          lg={4}
                          className="small_f"
                        >
                          <Dropdown
                            isDisabled={type === FOMRS.VIEW}
                            value={
                              data?.zone &&
                              getTimeZoneList?.filter(
                                (zone) => data?.zone === zone?.value
                              )
                            }
                            clearable
                            options={getTimeZoneList}
                            onChange={(e) => onTimeZoneChange(e, i)}
                            selection
                            placeholder="Select Timezone"
                          />
                        </Grid>
                      </Grid>
                    );
                  })}
              </Grid>

              <Grid Item xs={12} sm={12} md={12} lg={12} className="fieldDiv">
                <Grid xs={12} sm={12} md={12} lg={12} className="formLabel">
                  {type === FOMRS.ADD && (
                    <button className="AddCentreButton" onClick={onSubmit}>
                      {formField?.instructor_can_be_training_admin_checkbox
                        ? "Add Instructor And Training Center"
                        : "Add Training Center"}
                    </button>
                  )}
                  {type === "EDIT" && (
                    <button className="AddCentreButton" onClick={onSubmit}>
                      {formField?.instructor_can_be_training_admin_checkbox
                        ? "Update Instructor And Training Center"
                        : "Update Training Center"}
                    </button>
                  )}
                  {type === FOMRS.VIEW ? (
                    ""
                  ) : (
                    <button className="cancelButton" onClick={gotolistingPage}>
                      Cancel
                    </button>
                  )}
                </Grid>
              </Grid>
            </Grid>
          </>
        )}
        <ToastContainer
          position="bottom-right"
          autoClose={3000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
        />
      </div>
    </>
  );
};

export default AddTrainingCenterForm;
